import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/Login.vue')
    },
    {
        path: '/',
        component: () => import('@/views/Layout.vue'),
        children: [
            {
                path: '',
                name: 'OrgPage',
                component: () => import('@/views/OrgPage')
            },
            {
                path: '/find-device',
                name: 'FindDevicePage',
                component: () => import('@/views/FindDevicePage')
            },
            {
                path: '/org/devices',
                name: 'DevicePage',
                component: () => import('@/views/DevicePage')
            },
            {
                path: '/org/connection',
                name: 'ConnectionPage',
                component: () => import('@/views/ConnectionPage')
            },
            {
                path: '/org/log-attendance',
                name: 'LogAttendancePage',
                component: () => import('@/views/LogAttendancePage')
            },
            {
                path: '/org/log-alarm',
                name: 'LogAlarmPage',
                component: () => import('@/views/LogAlarmPage')
            },
            {
                path: '/org/users',
                name: 'UserPage',
                component: () => import('@/views/UserPage')
            },
            {
                path: '/org/log-activity',
                name: 'LogActivityPage',
                component: () => import('@/views/LogActivityPage')
            }
        ]
    }
]

const router = new VueRouter({
    routes
})

router.beforeEach(async (_to, _from, next) => {
    const org = sessionStorage.getItem('org')
    const isLogin = sessionStorage.getItem('login')
    if (_to.name !== _from.name) {
        if (isLogin !== null && org === null && (_to.name !== 'FindDevicePage' && _to.name !== 'OrgPage')) {
            next({ path: '/' })
        } else {
            next()
        }
    } else {
        if (!isLogin) {
            next({ path: '/login' })
        }
    }
})

export default router
